import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import {
  getSellerInsightsPhotoRecommendations,
  transformGetSellerInsightsPhotoRecommendationsResponse,
} from '@marketplace-web/seller-engagement-tools/seller-engagement-tools-data'

const useGetPhotoRecommendations = () => {
  const {
    fetch: fetchPhotoRecommendations,
    isLoading: isPhotoRecommendationsLoading,
    transformedData: photoRecommendations,
  } = useFetch(
    getSellerInsightsPhotoRecommendations,
    transformGetSellerInsightsPhotoRecommendationsResponse,
  )

  useEffect(() => {
    fetchPhotoRecommendations()
  }, [fetchPhotoRecommendations])

  return {
    photoRecommendations,
    isPhotoRecommendationsLoading,
  }
}

export default useGetPhotoRecommendations
